import { CoDocumento } from "../../codocumento/dominio/CoDocumento";
import { SyCampocalculado } from "src/app/erp/sistema/sycampocalculado/dominio/SyCampocalculado";

export class CoDocumentocobranzaPk {
    companiasocio: string;
    tipodocumento: string;
    numerodocumento: string;
    unidadreplicacion: string;
    cobranzanumero: number;
}
export class CoDocumentocobranza {

    pk: CoDocumentocobranzaPk;
    codocumento: CoDocumento;
    syCampocalculado: SyCampocalculado;

    constructor() {
        this.pk = new CoDocumentocobranzaPk();
        this.codocumento = new CoDocumento();
        this.syCampocalculado = new SyCampocalculado();
    }

    montopagado: number;
    recibonumero: string;
    tipodecambio: number;
    comentario: string;
    percepciontipodocumento: string;
    percepcionnumerodocumento: string;
    percepcionmonto: number;
    percepcionmontolocal: number;
    monto10: number;
    monto09: number;
    indicadorarchivamiento: number;

    get saldo(): number {
        if (this.syCampocalculado.monto01 - this.montopagado > 0) {
            return this.syCampocalculado.monto01 - this.montopagado;
        }
        return 0;
    }
}